var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      !_vm.hideLabel
        ? _c("label", { staticClass: "control-label col-md-3 col-sm-3" }, [
            _vm._v(_vm._s(_vm.label) + "\n    "),
            _vm.hasTooltip
              ? _c(
                  "a",
                  {
                    directives: [
                      {
                        name: "tooltip",
                        rawName: "v-tooltip.right",
                        value: _vm.tooltipText,
                        expression: "tooltipText",
                        modifiers: { right: true }
                      }
                    ]
                  },
                  [
                    _vm._v("\n        "),
                    _c("i", { staticClass: "fa fa-question-circle" })
                  ]
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._t("default")
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }